import React from "react";
import { navigate } from "gatsby";

type Props = {
  pages: Page[];
}

type Page = {
  current: boolean;
  name: string;
}

export default function Breadcrumbs(props: Props) {
  function getIndexToNavigatge(page:Page, idx:number){
    if(page.current) return 0;
    const index = props.pages.findIndex((p:Page) => p.current);
    if(index === -1) return 0;
    return idx - index;
  }

  return (
    <nav className="flex md:pb-4" aria-label="Breadcrumb">
      <ol role="list" className="flex items-center gap-2">
        {props.pages.map((page, idx) => {
          return <li key={page.name} onClick={() => {
              const index = getIndexToNavigatge(page, idx)
              if(index) navigate(index);
            }}>
            <div className={`flex items-center gap-2 ${!page.current ? "cursor-pointer" : ""}`}>
              {idx !== 0 ?
                <svg
                  className="h-5 w-5 flex-shrink-0 text-gray-300"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  aria-hidden="true"
                >
                  <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
                </svg>
                : null
              }
              <span
                className="text-sm font-medium text-gray-500 hover:text-gray-700"
                aria-current={page.current ? 'page' : undefined}
              >
                {page.name}
              </span>
            </div>
          </li>
      })}
      </ol>
    </nav>
  )
}